<template>
  <div class="notifications" @mouseenter="onMouseEnter()" @mouseleave="onMouseLeave()">
    <transition-group tag="div" name="notification">
      <Notification class="notification-item" :focused="!hovered && focused" :notification="notification" v-for="notification in notifications" :key="notification.id" @dismiss="removeNotification(notification)" />
      <div class="close-all" @click="closeAllNotifications()" v-if="notifications.length > 3" key="close" data-goal="NOTIFICATIONS_CLOSE_ALL">close all notifications</div>
      <div key="empty"></div>
    </transition-group>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import logger from '@/logger'
  import utils from '@/utils'
  import Notification from '@/components/Notification'

  export default {
    name: 'Notifications',
    components: {
      Notification,
    },
    data() {
      return {
        notifications: [],
        focused: true,
        hovered: false,
      }
    },
    computed: {
      ...mapGetters(['config']),
    },
    watch: {
      'config.notificationsOrder'() {
        this.closeAllNotifications()
      },
    },
    sockets: {
      notification(notification) {
        this.addNotification(notification)
      },
    },
    methods: {
      closeAllNotifications() {
        this.notifications = []
      },
      addNotification(notification) {
        notification.id = notification.id || utils.generateId()
        if (!this.notifications.find(item => item.id === notification.id)) {
          logger.info('New notification', {notification})
          if (this.config.notificationsOrder) {
            this.notifications.unshift(notification)
            if (this.notifications.length > this.config.notificationsCount) {
              this.notifications.pop()
            }
          } else {
            this.notifications.push(notification)
            if (this.notifications.length > this.config.notificationsCount) {
              this.notifications.shift()
            }
          }
        }
      },
      removeNotification(notification) {
        const index = this.notifications.findIndex(item => item.id ===  notification.id)
        this.notifications.splice(index, 1)
      },
      onMouseEnter() {
        this.hovered = true
      },
      onMouseLeave() {
        this.hovered = false
      },
      onBlur() {
        this.focused = false
      },
      onFocus() {
        this.focused = true
      },
    },
    created() {
      logger.notify = this.addNotification
      logger.closeAllNotifications = this.closeAllNotifications
      window.addEventListener('blur', this.onBlur)
      window.addEventListener('focus', this.onFocus)
    },
    beforeDestroy() {
      window.removeEventListener('blur', this.onBlur)
      window.removeEventListener('focus', this.onFocus)
    },
  }
</script>

<style scoped>
  .notifications { position: fixed; right: 1em; bottom: 6em; z-index: 999; }
  .close-all { margin: .5em 0 1em; text-align: right; font-size: .8em; font-weight: bold; cursor: pointer; }
  .close-all:hover { text-decoration: underline; }
</style>
